import { postMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const ADD_APPOINTMENTS = 'ADD_APPOINTMENTS';
export const ADD_APPOINTMENTS_SUCCESS = 'ADD_APPOINTMENTS_SUCCESS';
export const ADD_APPOINTMENTS_FAILURE = 'ADD_APPOINTMENTS_FAILURE';

// Action Creators
export const fetchAddAppointments = () => ({
  type: ADD_APPOINTMENTS,
});

export const fetchAddAppointmentsSuccess = (data) => ({
  type: ADD_APPOINTMENTS_SUCCESS,
  payload: data,
});

export const fetchAddAppointmentsFailure = (error) => ({
  type: ADD_APPOINTMENTS_FAILURE,
  payload: error,
});

// Thunk Function
export const addAppointmentsCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchAddAppointments(data, external));
    try {
      const response = await postMethodWithToken(
        url.addAppointmentsListProviderAdmin,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAddAppointmentsSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchAddAppointmentsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchAddAppointmentsFailure(error.message));
    }
  };
};
